const MinusIcon = ({ size = 13, color = "#2d2d2d" }: { size?: number; color?: string }) => {
    return (
        <svg
            style={{ height: size, width: size }}
            stroke={color}
            fill="none"
            strokeWidth="2.2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
    );
};

export default MinusIcon;
